const pricingTableContent = {
	features: [
		{
			content: "Synced orders per month",
			free: "30 orders",
			basic: "500 orders",
			pro: "6,000 orders",
			pro_plus: "25,000 orders",
			unlimited: "Unlimited orders",
		},
		{
			content: "PayPal Account",
			free: "Unlimited",
			basic: "Unlimited",
			pro: "Unlimited",
			pro_plus: "Unlimited",
			unlimited: "Unlimited",
		},
		{
			content: "Stripe Account",
			free: "icon_cancle",
			basic: "1",
			pro: "Unlimited",
			pro_plus: "Unlimited",
			unlimited: "Unlimited",
		},
		{
			content: "Sync previous orders",
			free: "icon_check",
			basic: "icon_check",
			pro: "icon_check",
			pro_plus: "icon_check",
			unlimited: "icon_check",
		},
		{
			content: "Auto-matching courier",
			free: "icon_check",
			basic: "icon_check",
			pro: "icon_check",
			pro_plus: "icon_check",
			unlimited: "icon_check",
		},
		{
			content: "Support all checkout gates",
			free: "icon_check",
			basic: "icon_check",
			pro: "icon_check",
			pro_plus: "icon_check",
			unlimited: "icon_check",
		},
		{
			content: "Multi Store Integration",
			free: "icon_cancle",
			basic: "icon_cancle",
			pro: "2 stores",
			pro_plus: "3 stores",
			unlimited: "4 stores",
		},

		{
			content: "Premium processing data",
			free: "icon_cancle",
			basic: "icon_cancle",
			pro: "icon_check",
			pro_plus: "icon_check",
			unlimited: "icon_check",
		},
		{
			content: "Courier matching rule",
			free: "icon_cancle",
			basic: "2 rules",
			pro: "10 rules",
			pro_plus: "Unlimited rules",
			unlimited: "Unlimited rules",
		},
		{
			content: "Advance customization",
			free: "icon_cancle",
			basic: "icon_cancle",
			pro: "icon_check",
			pro_plus: "icon_check",
			unlimited: "icon_check",
		},
	],
	priceMonthly: [
		{
			plan: "BASIC",
			price: 6.99,
		},
		{
			plan: "PRO",
			price: 9.99,
		},
		{
			plan: "PRO PLUS",
			price: 24.99,
		},
		{
			plan: "UNLIMITED",
			price: 39.99,
		},
	],
	priceAnnual: [
		{
			plan: "BASIC",
			total: 58.7,
			discount: 20,
			price: 4.89,
		},
		{
			plan: "PRO",
			total: 83.9,
			discount: 20,
			price: 6.99,
		},
		// {
		//   plan: "PRO PLUS",
		//   total: 134.3,
		//   price: 11.19,
		// },
		// {
		//   plan: "UNLIMITED",
		//   total: 293.9,
		//   discount: 20,
		//   price: 24.49,
		// },
		{
			plan: "PRO PLUS",
			total: 209.9,
			discount: 30,
			price: 17.49,
		},
		{
			plan: "UNLIMITED",
			total: 335.9,
			discount: 30,
			price: 27.99,
		},
	],
	listPlan: ["free", "basic", "pro", "pro_plus", "unlimited"],
};
export default pricingTableContent;
